/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfFeedbackDetailDto } from '../../models/platform-api-result-of-feedback-detail-dto';
import { PlatformSetFeedbackPriority } from '../../models/platform-set-feedback-priority';

export interface PostFeedbackManageActionSetPriority$Params {
      body: PlatformSetFeedbackPriority
}

export function postFeedbackManageActionSetPriority(http: HttpClient, rootUrl: string, params: PostFeedbackManageActionSetPriority$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
  const rb = new RequestBuilder(rootUrl, postFeedbackManageActionSetPriority.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>;
    })
  );
}

postFeedbackManageActionSetPriority.PATH = '/api/feedback/manage/action/set-priority';
